import { system } from "portalframework";
import * as ko from "knockout";
import * as _ from "lodash";
import * as $ from "jquery";
import { personExtended, TfaSettings } from "organized";
import { BaseService } from "../_common/_baseService";
import { portalHttpService } from "../_common/httpService";
import * as toastr from "toastr";
import { PopupConfig } from "components/request-incident/incident-popup-config/PopupConfig";
import { USER_LANGUAGE_KEY } from "app/app-constants";

class ProfileService extends BaseService {
  /**
   *
   */
  constructor() {
    super("Profile");
  }
  public getProfile = async (): Promise<personExtended> => {
    const profile = await portalHttpService.get(`${this.baseApiUrl()}/GetProfile`);
    return new personExtended(profile);
  };

  public getSignature = async (): Promise<string> => {
    const attachment: any = await portalHttpService.get<any>(`${system.apiURL()}api/Profile/GetSignature`);

    if (attachment) {
      return `data:image/jpeg;base64,${attachment.base64_img}`;
    }

    return null;
  };

  public resetSignature = async (): Promise<void> => {
    await portalHttpService.get<any>(`${system.apiURL()}api/Profile/ResetSignature`);
  };

  public changePassword = async (password: any, confirm: any): Promise<void> => {
    const locale = localStorage.getItem(USER_LANGUAGE_KEY);
    await portalHttpService.post<any>(
      system.apiURL() + "api/Profile/changePassword",
      ko.toJSON({ password: password, confirm: confirm, locale: locale }),
    );
  };

  public confirmDeleteAccount = async (): Promise<string> => {
    return await portalHttpService.post<any>(system.apiURL() + "api/Profile/confirmDeleteAccount");
  };

  public editProfile = async (person: personExtended): Promise<void> => {
    const locale = localStorage.getItem(USER_LANGUAGE_KEY);
    await portalHttpService.post<any>(
      system.apiURL() + "api/Profile/EditProfile",
      ko.toJSON({
        ...person,
        locale: locale,
      }),
    );
  };

  public changeLanguage = async (language: string) => {
    if (system.signedIn && system.signedIn()) {
      try {
        let data = ko.toJSON({ selected_language: language });
        const result = await portalHttpService.post<any>(system.apiURL() + `api/language/setLanguage`, data);
        localStorage.setItem(USER_LANGUAGE_KEY, result.results.person.locale_code);
        window.location.reload();
      } catch (error) {
        toastr.error(error);
        window.setTimeout(function () {
          window.history.back();
        }, 3000);
      }
    } else {
      localStorage.setItem(USER_LANGUAGE_KEY, language);
      window.location.reload();
    }
  };

  public getAllSystemLanguages = async () => {
    const data = await portalHttpService.post<any>(system.apiURL() + `api/language/GetAllSystemLanguages`);
    const languages = data.result.results["LOCALE_CODE"];

    if (languages) {
      localStorage.setItem("LOCALE_CODE", ko.toJSON(languages));
    }
  };

  getIncidentPopupConfiguration = async (): Promise<PopupConfig> => {
    const configuration = await portalHttpService.get<any>(
      `${system.apiURL()}api/Profile/GetIncidentPopupConfiguration`,
    );

    return configuration ? new PopupConfig(configuration) : null;
  };

  saveIncidentPopupConfiguration = async (configuration: PopupConfig) => {
    await portalHttpService.post<any>(
      `${system.apiURL()}api/Profile/SaveIncidentPopupConfiguration`,
      ko.toJSON(configuration),
    );
  };

  getTFASettings = async () => {
    const result = await portalHttpService.get<any>(`${this.baseApiUrl()}/GetTFASettings`);
    return new TfaSettings(result);
  };

  addressChangeRequest = async (addressChangeText: string, currentAddress: string): Promise<void> => {
    const locale = localStorage.getItem(USER_LANGUAGE_KEY);
    await portalHttpService.post<any>(
      `${system.apiURL()}api/Profile/RequestUserAddressChange`,
      ko.toJSON({ address: addressChangeText, current_address: currentAddress, locale }),
    );
  };

  getCurrentUserAddress = async (): Promise<string> => {
    const result = await portalHttpService.get<any>(`${system.apiURL()}api/Profile/GetCurrentUserShipToAddress`);
    return result?.address || "";
  };
}

export const profileService = new ProfileService();
